import Flex from "@components/ui-components/flex";
import LoadingButton from "@components/ui-components/loading-button";
import ReactCalendar from "@components/ui-components/calendar";
import { UpsertMeetings } from "./upsert/upsert";
import useMeetings from "./use-meeting";
import { useTranslation } from "react-i18next";

const Meetings = () => {
    const {
        events,
        loading,
        getCalendarEvents,
        toggleModal,
        modalConfig,
        date,
        handleMonthChange,
        handleEventSelect,
        handleSlotSelect
    } = useMeetings();

    const isEdit = !!modalConfig.row.id;
    const { t } = useTranslation();

    return (
        <>
            <Flex className="w-100 mb-1 border-bottom pb-1" justify="between" align="center">
                <h1>{t("Meetings")}</h1>
                <LoadingButton
                    text="Add Meeting"
                    icon="plus"
                    onClick={toggleModal}
                    className="details-page-add-button"/>
            </Flex>
            <ReactCalendar
                date={date}
                onNavigate={handleMonthChange}
                loading={loading}
                events={events}
                onSelectSlot={handleSlotSelect}
                onSelectEvent={handleEventSelect}/>

            <UpsertMeetings
                isEdit={isEdit}
                modalConfig={modalConfig}
                toggleModal={toggleModal}
                getEvents={getCalendarEvents}/>
        </>
    );
};

export default Meetings;
